import {post, get, patch, remove, put} from '@/lib/axios';

const studyPlan = {
  async fetchEvents({year}) {
    return get(`/planning/${year}`);
  },
  async createEvent({type, start, end, time, comment}) {
    return post('/planning/event', {
      type,
      start,
      end,
      time,
      comment,
    });
  },
  async updateEvent({type, start, end, time, comment, id}) {
    return patch(`/planning/event/${id}`, {
      type,
      start,
      end,
      time,
      comment,
    });
  },
  async deleteEvent({id}) {
    return remove(`/planning/event/${id}`);
  },
  async fetchEventTypes({lang}) {
    return get(`/planning/types/${lang}`);
  },
  async fetchRequests({column, sort, page}) {
    return get('/planning/request', {column, sort, page});
  },
  async fetchRequestFormFields() {
    return get('/planning/request/form');
  },
  async createRequest({start, comment, startTime, segments, company, employees, phone}) {
    return post('/planning/request', {
      start,
      comment,
      startTime,
      segments,
      employees,
      company,
      phone,
    });
  },
  async updateRequestStatus({requestId, status}) {
    return put(`/planning/request/${requestId}`, {status});
  },
};

export {studyPlan as default};
